<script>
import axios from 'axios';
import Layout from '@/layouts/main.vue';
import PageHeader from '@/components/page-header';
import socketClient from '@/services/socketClient';

export default {
  name: 'CanaisBaileys',
  components: { Layout, PageHeader },
  data() {
    return {
      canais: [],
      carregando: true,
      erro: null,
      sucesso: null,
      modalCriar: false,
      modalQr: false,
      modalTipos: false,
      criando: false,
      salvandoTipos: false,
      novoCanal: { nome: '', tipos: ['operacao'] },
      tiposEdicao: { canalId: null, tipos: [] },
      // Rodízio de disparo: situação dos chips (GET /canal/baileys/poolDisparo).
      pool: null,
      poolTimer: null,
      // Modo lote: conecta chips de disparo em sequência (cria → QR → próximo).
      modoLote: false,
      conectadosNoLote: 0,
      canalSelecionado: null,
      qrAtual: null,
      statusAtual: null,
      erroConexao: null,
      qrPollTimer: null,
      offSocket: [],
    };
  },
  computed: {
    temChipsDisparo() {
      return this.canais.some((c) => Array.isArray(c.tipos) && c.tipos.includes('disparo'));
    },
    poolPorId() {
      const m = {};
      ((this.pool && this.pool.chips) || []).forEach((c) => { m[c.id] = c; });
      return m;
    },
  },
  async mounted() {
    await this.carregar();
    this.bindSocket();
    this.carregarPool();
    this.poolTimer = setInterval(() => { if (this.temChipsDisparo) this.carregarPool(); }, 30000);
  },
  beforeUnmount() {
    this.offSocket.forEach((fn) => { try { fn(); } catch (_e) { /* noop */ } });
    this.pararPollingQr();
    if (this.poolTimer) clearInterval(this.poolTimer);
  },
  methods: {
    async carregar() {
      this.carregando = true;
      try {
        const { data } = await axios.get('/canal/baileys', {
          params: { order: JSON.stringify([['id', 'desc']]) },
        });
        this.canais = Array.isArray(data) ? data : [];
      } catch (error) {
        this.erro = `Falha ao listar canais: ${error.message}`;
      } finally {
        this.carregando = false;
      }
    },

    async carregarPool() {
      try {
        const { data } = await axios.get('/canal/baileys/poolDisparo');
        this.pool = data || null;
      } catch (_e) { /* painel é opcional */ }
    },

    async retomarChip(canal) {
      try {
        await axios.post(`/canal/baileys/retomarDisparo/${canal.id}`);
        this.sucesso = `Chip "${canal.nome}" de volta ao rodízio.`;
        this.carregarPool();
      } catch (error) {
        this.erro = `Falha ao retomar chip: ${error.response?.data?.error || error.message}`;
      }
    },

    /** Próximo nome da sequência "Disparo 001", "Disparo 002"... */
    proximoNomeDisparo() {
      let max = 0;
      this.canais.forEach((c) => {
        const m = /^Disparo (\d+)$/.exec(String(c.nome || '').trim());
        if (m) max = Math.max(max, Number(m[1]));
      });
      return `Disparo ${String(max + 1).padStart(3, '0')}`;
    },

    /**
     * Modo lote: cria o próximo chip de disparo e já abre o QR. Ao conectar, o
     * modal oferece "Próximo chip" — ativar dezenas de números vira escanear,
     * clicar, escanear.
     */
    async conectarProximoDisparo() {
      this.modoLote = true;
      this.erro = null;
      try {
        const { data: canal } = await axios.post('/canal/baileys', {
          nome: this.proximoNomeDisparo(),
          tipos: ['disparo'],
        });
        this.canais.unshift(canal);
        this.abrirQr(canal, false);
      } catch (error) {
        this.erro = `Falha ao criar chip: ${error.response?.data?.error || error.message}`;
      }
    },

    bindSocket() {
      const u = JSON.parse(localStorage.getItem('userdata') || '{}');
      socketClient.connect(u && u.id);

      this.offSocket.push(socketClient.on('baileys:qr', (payload) => {
        if (!payload) return;
        if (this.canalSelecionado && payload.canalId === this.canalSelecionado.id) {
          this.qrAtual = payload.qr;
          this.statusAtual = 'pareando';
        }
        // Atualiza canal na lista
        const c = this.canais.find((x) => x.id === payload.canalId);
        if (c) { c.ultimo_qr = payload.qr; c.status = 'pareando'; }
      }));

      this.offSocket.push(socketClient.on('baileys:status', (payload) => {
        if (!payload) return;
        const c = this.canais.find((x) => x.id === payload.canalId);
        if (c) {
          c.status = payload.status;
          if (payload.telefone) c.telefone = payload.telefone;
          if (payload.status === 'conectado') c.ultimo_qr = null;
        }
        if (this.canalSelecionado && payload.canalId === this.canalSelecionado.id) {
          this.statusAtual = payload.status;
          if (payload.status === 'conectado') {
            this.qrAtual = null;
            this.sucesso = `Canal "${this.canalSelecionado.nome}" conectado: ${payload.telefone || ''}`;
            // No modo lote o modal fica aberto oferecendo o próximo chip.
            if (this.modoLote) this.conectadosNoLote += 1;
            else setTimeout(() => { this.modalQr = false; this.canalSelecionado = null; }, 1200);
          }
        }
        if (this.temChipsDisparo) this.carregarPool();
      }));
    },

    abrirCriar() {
      this.novoCanal = { nome: '', tipos: ['operacao'] };
      this.erro = null;
      this.sucesso = null;
      this.modalCriar = true;
    },

    toggleTipoNovo(tipo) {
      const i = this.novoCanal.tipos.indexOf(tipo);
      if (i >= 0) this.novoCanal.tipos.splice(i, 1);
      else this.novoCanal.tipos.push(tipo);
    },

    async confirmarCriar() {
      if (!this.novoCanal.nome.trim()) { this.erro = 'Informe um nome.'; return; }
      if (!this.novoCanal.tipos.length) { this.erro = 'Marque ao menos um tipo (Operação e/ou Higienização).'; return; }
      this.criando = true;
      try {
        const { data: canal } = await axios.post('/canal/baileys', {
          nome: this.novoCanal.nome.trim(),
          tipos: this.novoCanal.tipos,
        });
        this.canais.unshift(canal);
        this.modalCriar = false;
        // O backend já iniciou a sessão nova no create — só abre o modal e faz
        // polling do QR; não força novo start (autoGerar=false).
        this.abrirQr(canal, false);
      } catch (error) {
        this.erro = `Falha ao criar canal: ${error.response?.data?.error || error.message}`;
      } finally {
        this.criando = false;
      }
    },

    abrirEditarTipos(canal) {
      this.tiposEdicao = {
        canalId: canal.id,
        tipos: Array.isArray(canal.tipos) ? [...canal.tipos] : ['operacao'],
      };
      this.modalTipos = true;
    },

    toggleTipoEdicao(tipo) {
      const i = this.tiposEdicao.tipos.indexOf(tipo);
      if (i >= 0) this.tiposEdicao.tipos.splice(i, 1);
      else this.tiposEdicao.tipos.push(tipo);
    },

    async salvarTipos() {
      if (!this.tiposEdicao.tipos.length) { this.erro = 'Marque ao menos um tipo.'; return; }
      this.salvandoTipos = true;
      try {
        const { data } = await axios.put(`/canal/baileys/${this.tiposEdicao.canalId}`, {
          tipos: this.tiposEdicao.tipos,
        });
        const idx = this.canais.findIndex((c) => c.id === this.tiposEdicao.canalId);
        if (idx >= 0) this.canais.splice(idx, 1, { ...this.canais[idx], ...data });
        this.modalTipos = false;
        this.sucesso = 'Tipos atualizados.';
        this.carregarPool();
      } catch (error) {
        this.erro = `Falha ao atualizar tipos: ${error.response?.data?.error || error.message}`;
      } finally {
        this.salvandoTipos = false;
      }
    },

    abrirQr(canal, autoGerar = true) {
      this.canalSelecionado = canal;
      this.qrAtual = canal.ultimo_qr || null;
      this.statusAtual = canal.status;
      this.erroConexao = null;
      this.modalQr = true;
      // Canal não conectado: força um QR novo do zero. É o que resolve o caso do
      // print — sessão morta ("WebSocket Error"/"QR refs attempts ended") presa em
      // "pareando", sem sessão viva gerando QR. Abrir o modal só lia o `ultimo_qr`
      // (nulo) e ficava em "Aguardando QR" pra sempre. Com `autoGerar=false`
      // (usado no create, que já iniciou no backend) apenas faz polling.
      if (autoGerar && canal.status !== 'conectado') {
        this.gerarNovoQr();
      } else {
        // O QR chega por socket, mas o backend também PERSISTE em `ultimo_qr` e
        // expõe em GET /status/:id — o polling é a rede de segurança quando o
        // realtime não chega.
        this.iniciarPollingQr();
      }
    },

    fecharQr() {
      this.modoLote = false;
      this.conectadosNoLote = 0;
      this.pararPollingQr();
      this.modalQr = false;
      this.canalSelecionado = null;
      this.qrAtual = null;
      this.statusAtual = null;
      this.erroConexao = null;
    },

    iniciarPollingQr() {
      this.pararPollingQr();
      let polls = 0;
      const tick = async () => {
        if (!this.canalSelecionado) return;
        polls += 1;
        try {
          const { data } = await axios.get(`/canal/baileys/status/${this.canalSelecionado.id}`);
          if (!this.canalSelecionado || data.id !== this.canalSelecionado.id) return;
          if (data.ultimo_qr && data.status !== 'conectado') this.qrAtual = data.ultimo_qr;
          this.statusAtual = data.statusMemoria || data.status;

          const erroDuro = ['erro', 'banido'].includes(data.status);
          // Sessão expirada (loggedOut) volta como "desconectado" com motivo e
          // NUNCA gera QR sozinha — o usuário precisa do "Gerar novo QR". Só
          // sinalizamos depois de alguns polls pra não piscar o erro velho no
          // instante em que a nova tentativa ainda está subindo.
          const sessaoExpirada = data.status === 'desconectado' && !!data.ultimo_erro && !this.qrAtual && polls >= 2;

          if (data.status === 'conectado') {
            this.qrAtual = null;
            this.erroConexao = null;
            this.pararPollingQr();
          } else if (erroDuro || sessaoExpirada) {
            this.erroConexao = data.ultimo_erro
              || 'Sessão expirada. Clique em "Gerar novo QR" para reconectar.';
          } else {
            this.erroConexao = null;
          }
        } catch (_e) { /* silencioso — é só fallback */ }
      };
      tick();
      this.qrPollTimer = setInterval(tick, 3000);
    },

    pararPollingQr() {
      if (this.qrPollTimer) { clearInterval(this.qrPollTimer); this.qrPollTimer = null; }
    },

    // Botão do modal de QR: força credenciais do zero (novoQr) para GARANTIR um
    // QR novo — mesmo quando a sessão salva expirou e a retomada não geraria QR.
    async gerarNovoQr() {
      if (!this.canalSelecionado) return;
      this.qrAtual = null;
      this.erroConexao = null;
      this.statusAtual = 'pareando';
      try {
        await axios.post(`/canal/baileys/iniciar/${this.canalSelecionado.id}`, { novoQr: true });
        this.iniciarPollingQr();
      } catch (error) {
        this.erroConexao = error.response?.data?.error || error.message;
      }
    },

    /** Chip que já foi pareado alguma vez (tem sessão salva no servidor). */
    jaPareado(canal) {
      return !!(canal && (canal.telefone || canal.conectado_em));
    },

    /**
     * Reconectar = RELIGAR com a sessão salva. Antes ia direto para o QR novo,
     * que apaga a sessão: um chip que só tinha caído (e voltaria sozinho)
     * perdia o pareamento e era preciso escanear de novo no celular. QR novo
     * agora é ação separada e explícita ("Novo QR"). Chip nunca pareado não
     * tem o que religar: vai direto ao QR.
     */
    async reconectar(canal) {
      if (!this.jaPareado(canal)) {
        this.abrirQr(canal);
        return;
      }
      this.erro = null;
      try {
        await axios.post(`/canal/baileys/iniciar/${canal.id}`);
        canal.status = 'reconectando';
        this.sucesso = `Religando "${canal.nome}" com a sessão salva. Se não voltar em alguns segundos, use "Novo QR".`;
      } catch (error) {
        this.erro = `Falha ao religar: ${error.response?.data?.error || error.message}`;
      }
    },

    /** QR novo de propósito: apaga a sessão salva e pede para escanear de novo. */
    novoQr(canal) {
      if (!window.confirm(`Gerar QR novo para "${canal.nome}"?\n\nA sessão salva será apagada e será preciso escanear o QR no celular de novo. Use só se "Reconectar" não resolver.`)) return;
      this.abrirQr(canal);
    },

    async desconectar(canal) {
      if (!window.confirm(`Desconectar canal "${canal.nome}"? Credenciais serão preservadas para reconexão.`)) return;
      try {
        const { data } = await axios.post(`/canal/baileys/desconectar/${canal.id}`);
        const idx = this.canais.findIndex((c) => c.id === canal.id);
        if (idx >= 0) this.canais.splice(idx, 1, data);
      } catch (error) {
        this.erro = `Falha ao desconectar: ${error.response?.data?.error || error.message}`;
      }
    },

    async logout(canal) {
      if (!window.confirm(`Fazer LOGOUT do canal "${canal.nome}"? As credenciais serão apagadas — será necessário escanear novo QR.`)) return;
      try {
        const { data } = await axios.post(`/canal/baileys/logout/${canal.id}`);
        const idx = this.canais.findIndex((c) => c.id === canal.id);
        if (idx >= 0) this.canais.splice(idx, 1, data);
      } catch (error) {
        this.erro = `Falha no logout: ${error.response?.data?.error || error.message}`;
      }
    },

    async remover(canal) {
      if (!window.confirm(`REMOVER o canal "${canal.nome}"? Esta ação não pode ser desfeita.`)) return;
      try {
        await axios.delete(`/canal/baileys/${canal.id}`);
        this.canais = this.canais.filter((c) => c.id !== canal.id);
      } catch (error) {
        this.erro = `Falha ao remover: ${error.response?.data?.error || error.message}`;
      }
    },

    statusBadge(status) {
      const map = {
        conectado:    'bg-success-subtle text-success',
        pareando:     'bg-warning-subtle text-warning',
        reconectando: 'bg-info-subtle text-info',
        desconectado: 'bg-secondary-subtle text-secondary',
        banido:       'bg-danger-subtle text-danger',
        erro:         'bg-danger-subtle text-danger',
      };
      return map[status] || 'bg-light';
    },

    rotuloTipo(t) {
      return { higienizacao: 'Higienização', disparo: 'Disparo' }[t] || 'Operação';
    },
    classeTipo(t) {
      return {
        higienizacao: 'bg-info-subtle text-info',
        disparo: 'bg-warning-subtle text-warning',
      }[t] || 'bg-success-subtle text-success';
    },
    iconeTipo(t) {
      return { higienizacao: 'ri-shield-check-line', disparo: 'ri-send-plane-line' }[t] || 'ri-broadcast-line';
    },
    fmt(n) {
      return Number(n || 0).toLocaleString('pt-BR');
    },
    hora(d) {
      return d ? new Date(d).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : '';
    },

    formatarData(d) {
      if (!d) return '—';
      try { return new Date(d).toLocaleString('pt-BR'); } catch (_e) { return '—'; }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader title="Canais API-B" pageTitle="Canais API-B" />

    <BCard no-body>
      <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div>
          <h5 class="m-0">Conexões WhatsApp via API-B (QR code)</h5>
          <small class="text-muted">
            Use para acessar recursos não disponíveis na Cloud API (ex.: grupos).
            <strong>Atenção:</strong> protocolo não-oficial — risco de banimento se houver spam.
          </small>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          <button type="button" class="btn btn-soft-warning" title="Cria chips 'Disparo 001', 'Disparo 002'... e abre o QR de um por vez" @click="conectarProximoDisparo">
            <i class="ri-send-plane-line me-1"></i>Conectar chips de disparo
          </button>
          <button type="button" class="btn btn-success" @click="abrirCriar">
            <i class="ri-qr-code-line me-1"></i>Conectar novo número
          </button>
        </div>
      </div>

      <div class="card-body">
        <div v-if="erro" class="alert alert-danger">
          <i class="ri-error-warning-line me-1"></i>{{ erro }}
          <button class="btn-close float-end" @click="erro = null"></button>
        </div>
        <div v-if="sucesso" class="alert alert-success">
          <i class="ri-checkbox-circle-line me-1"></i>{{ sucesso }}
          <button class="btn-close float-end" @click="sucesso = null"></button>
        </div>

        <!-- Painel do rodízio de disparo -->
        <div v-if="pool && pool.totalChips" class="pool-disparo border rounded p-3 mb-3">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
            <strong><i class="ri-send-plane-line me-1 text-warning"></i>Rodízio de disparo (campanhas)</strong>
            <button type="button" class="btn btn-sm btn-link text-muted p-0" title="Atualizar" @click="carregarPool"><i class="ri-refresh-line"></i></button>
          </div>
          <div class="row g-2 text-center">
            <div class="col-6 col-md-2"><div class="pool-kpi"><small class="text-muted d-block">Chips</small><span class="fs-5 fw-semibold">{{ pool.totalChips }}</span></div></div>
            <div class="col-6 col-md-2"><div class="pool-kpi"><small class="text-muted d-block">Conectados</small><span class="fs-5 fw-semibold text-success">{{ pool.conectados }}</span></div></div>
            <div class="col-6 col-md-2"><div class="pool-kpi"><small class="text-muted d-block">Pausados</small><span class="fs-5 fw-semibold" :class="pool.pausados ? 'text-warning' : ''">{{ pool.pausados }}</span></div></div>
            <div class="col-6 col-md-2"><div class="pool-kpi"><small class="text-muted d-block">Enviados hoje</small><span class="fs-5 fw-semibold">{{ fmt(pool.enviadosHoje) }}</span></div></div>
            <div class="col-6 col-md-2"><div class="pool-kpi"><small class="text-muted d-block">Disponíveis agora</small><span class="fs-5 fw-semibold text-primary">{{ pool.disponiveis }}</span></div></div>
            <div class="col-6 col-md-2"><div class="pool-kpi"><small class="text-muted d-block">Vazão</small><span class="fs-5 fw-semibold">~{{ fmt(pool.vazaoPorHora) }}/h</span></div></div>
          </div>
          <small class="text-muted d-block mt-2">
            Sem teto diário por chip · intervalo médio {{ pool.intervaloMedioS }}s por chip
            (Customização → Parâmetros → Campanhas).
          </small>
        </div>

        <div v-if="carregando" class="text-center text-muted py-4">
          <i class="ri-loader-4-line spin"></i> Carregando canais...
        </div>
        <div v-else-if="!canais.length" class="text-center text-muted py-5">
          <i class="ri-whatsapp-line" style="font-size: 2rem;"></i>
          <div class="mt-2">Nenhum canal API-B conectado. Clique em "Conectar novo número" pra começar.</div>
        </div>
        <div v-else class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Telefone</th>
                <th>Tipos</th>
                <th>Status</th>
                <th v-if="temChipsDisparo">Disparo hoje</th>
                <th>Conectado em</th>
                <th>Último erro</th>
                <th style="min-width: 260px;">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c in canais" :key="c.id">
                <td><strong>{{ c.nome }}</strong></td>
                <td>{{ c.telefone || '—' }}</td>
                <td>
                  <span
                    v-for="t in (Array.isArray(c.tipos) ? c.tipos : [])"
                    :key="t"
                    class="badge me-1"
                    :class="classeTipo(t)"
                  >
                    <i :class="iconeTipo(t)" class="me-1"></i>
                    {{ rotuloTipo(t) }}
                  </span>
                  <button type="button" class="btn btn-sm btn-link text-muted p-0 ms-1" title="Editar tipos" @click="abrirEditarTipos(c)">
                    <i class="ri-pencil-line"></i>
                  </button>
                </td>
                <td><span class="badge text-capitalize" :class="statusBadge(c.status)">{{ c.status }}</span></td>
                <td v-if="temChipsDisparo" class="text-nowrap">
                  <template v-if="poolPorId[c.id]">
                    {{ poolPorId[c.id].enviadosHoje }}
                    <span v-if="poolPorId[c.id].falhasHoje" class="text-danger small ms-1">{{ poolPorId[c.id].falhasHoje }} falha(s)</span>
                    <div v-if="poolPorId[c.id].pausado" class="small">
                      <span class="badge bg-warning-subtle text-warning" :title="poolPorId[c.id].ultimoErro">Pausado até {{ hora(poolPorId[c.id].pausadoAte) }}</span>
                      <button type="button" class="btn btn-sm btn-link p-0 ms-1" @click="retomarChip(c)">Retomar</button>
                    </div>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>{{ formatarData(c.conectado_em) }}</td>
                <td class="text-truncate" style="max-width: 240px;" :title="c.ultimo_erro">{{ c.ultimo_erro || '—' }}</td>
                <td>
                  <button
                    v-if="c.status === 'pareando' || c.ultimo_qr"
                    type="button"
                    class="btn btn-sm btn-outline-warning me-1"
                    @click="abrirQr(c)"
                  >
                    <i class="ri-qr-code-line me-1"></i>QR
                  </button>
                  <button
                    v-if="!['conectado', 'pareando', 'reconectando'].includes(c.status)"
                    type="button"
                    class="btn btn-sm btn-outline-primary me-1"
                    :title="jaPareado(c) ? 'Religa usando a sessão salva (não precisa escanear)' : 'Mostra o QR para parear'"
                    @click="reconectar(c)"
                  >
                    <i class="ri-restart-line me-1"></i>Reconectar
                  </button>
                  <button
                    v-if="c.status !== 'conectado' && c.status !== 'pareando' && jaPareado(c)"
                    type="button"
                    class="btn btn-sm btn-outline-warning me-1"
                    title="Apaga a sessão salva e mostra um QR novo para escanear"
                    @click="novoQr(c)"
                  >
                    <i class="ri-qr-code-line me-1"></i>Novo QR
                  </button>
                  <button
                    v-if="c.status === 'conectado'"
                    type="button"
                    class="btn btn-sm btn-outline-secondary me-1"
                    @click="desconectar(c)"
                  >
                    <i class="ri-pause-line me-1"></i>Pausar
                  </button>
                  <button
                    v-if="c.status === 'conectado' || c.status === 'erro'"
                    type="button"
                    class="btn btn-sm btn-outline-danger me-1"
                    @click="logout(c)"
                  >
                    <i class="ri-logout-box-r-line me-1"></i>Logout
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    @click="remover(c)"
                  >
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </BCard>

    <!-- Modal: criar canal -->
    <div v-if="modalCriar" class="modal-baileys-overlay" @click.self="modalCriar = false">
      <div class="modal-baileys-content">
        <div class="modal-baileys-header">
          <h5 class="m-0">Novo canal API-B</h5>
          <button class="btn-close" @click="modalCriar = false"></button>
        </div>
        <div class="modal-baileys-body">
          <div class="mb-3">
            <label class="form-label">Nome identificador</label>
            <input v-model="novoCanal.nome" type="text" class="form-control" placeholder="Ex: PCdoB-RJ-Mobilização" @keyup.enter="confirmarCriar" />
          </div>
          <div class="mb-2">
            <label class="form-label">Tipos (escolha pelo menos um)</label>
            <div class="d-flex flex-column gap-2">
              <label class="tipo-card" :class="{ 'tipo-card--ativo': novoCanal.tipos.includes('operacao') }">
                <input type="checkbox" :checked="novoCanal.tipos.includes('operacao')" @change="toggleTipoNovo('operacao')" />
                <div class="tipo-info">
                  <strong><i class="ri-broadcast-line me-1 text-success"></i>Operação</strong>
                  <small class="text-muted">Aparece em Grupos e Canais (newsletter). Use pra conversa/postagem real.</small>
                </div>
              </label>
              <label class="tipo-card" :class="{ 'tipo-card--ativo': novoCanal.tipos.includes('higienizacao') }">
                <input type="checkbox" :checked="novoCanal.tipos.includes('higienizacao')" @change="toggleTipoNovo('higienizacao')" />
                <div class="tipo-info">
                  <strong><i class="ri-shield-check-line me-1 text-info"></i>Higienização</strong>
                  <small class="text-muted">Aparece na tela de Higienização do WhatsApp. Use pra validar telefones em massa.</small>
                </div>
              </label>
              <label class="tipo-card" :class="{ 'tipo-card--ativo': novoCanal.tipos.includes('disparo') }">
                <input type="checkbox" :checked="novoCanal.tipos.includes('disparo')" @change="toggleTipoNovo('disparo')" />
                <div class="tipo-info">
                  <strong><i class="ri-send-plane-line me-1 text-warning"></i>Disparo</strong>
                  <small class="text-muted">Entra no rodízio de chips das campanhas. Só "Disparo" não sincroniza grupos.</small>
                </div>
              </label>
            </div>
          </div>
          <small class="text-muted d-block mt-2">Após criar, escaneie o QR code com o WhatsApp do número que será conectado.</small>
        </div>
        <div class="modal-baileys-footer">
          <button type="button" class="btn btn-light" @click="modalCriar = false">Cancelar</button>
          <button type="button" class="btn btn-success" :disabled="criando || !novoCanal.nome.trim() || !novoCanal.tipos.length" @click="confirmarCriar">
            <i v-if="criando" class="ri-loader-4-line spin me-1"></i>
            {{ criando ? 'Criando...' : 'Criar e gerar QR' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal: editar tipos -->
    <div v-if="modalTipos" class="modal-baileys-overlay" @click.self="modalTipos = false">
      <div class="modal-baileys-content">
        <div class="modal-baileys-header">
          <h5 class="m-0">Editar tipos do canal</h5>
          <button class="btn-close" @click="modalTipos = false"></button>
        </div>
        <div class="modal-baileys-body">
          <div class="d-flex flex-column gap-2">
            <label class="tipo-card" :class="{ 'tipo-card--ativo': tiposEdicao.tipos.includes('operacao') }">
              <input type="checkbox" :checked="tiposEdicao.tipos.includes('operacao')" @change="toggleTipoEdicao('operacao')" />
              <div class="tipo-info">
                <strong><i class="ri-broadcast-line me-1 text-success"></i>Operação</strong>
                <small class="text-muted">Aparece em Grupos e Canais (newsletter).</small>
              </div>
            </label>
            <label class="tipo-card" :class="{ 'tipo-card--ativo': tiposEdicao.tipos.includes('higienizacao') }">
              <input type="checkbox" :checked="tiposEdicao.tipos.includes('higienizacao')" @change="toggleTipoEdicao('higienizacao')" />
              <div class="tipo-info">
                <strong><i class="ri-shield-check-line me-1 text-info"></i>Higienização</strong>
                <small class="text-muted">Aparece na tela de Higienização do WhatsApp.</small>
              </div>
            </label>
            <label class="tipo-card" :class="{ 'tipo-card--ativo': tiposEdicao.tipos.includes('disparo') }">
              <input type="checkbox" :checked="tiposEdicao.tipos.includes('disparo')" @change="toggleTipoEdicao('disparo')" />
              <div class="tipo-info">
                <strong><i class="ri-send-plane-line me-1 text-warning"></i>Disparo</strong>
                <small class="text-muted">Entra no rodízio de chips das campanhas.</small>
              </div>
            </label>
          </div>
          <small v-if="!tiposEdicao.tipos.length" class="text-danger d-block mt-2">Marque ao menos um tipo.</small>
        </div>
        <div class="modal-baileys-footer">
          <button type="button" class="btn btn-light" @click="modalTipos = false">Cancelar</button>
          <button type="button" class="btn btn-success" :disabled="salvandoTipos || !tiposEdicao.tipos.length" @click="salvarTipos">
            <i v-if="salvandoTipos" class="ri-loader-4-line spin me-1"></i>
            {{ salvandoTipos ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal: QR code -->
    <div v-if="modalQr && canalSelecionado" class="modal-baileys-overlay" @click.self="fecharQr">
      <div class="modal-baileys-content">
        <div class="modal-baileys-header">
          <h5 class="m-0">Conectar: {{ canalSelecionado.nome }}</h5>
          <button class="btn-close" @click="fecharQr"></button>
        </div>
        <div class="modal-baileys-body text-center">
          <div v-if="qrAtual">
            <img :src="qrAtual" alt="QR Code" style="width: 280px; max-width: 100%; border-radius: 12px;" />
            <p class="text-muted mt-3 mb-0">
              Abra o WhatsApp no celular → Configurações → Aparelhos conectados → Conectar um aparelho.
            </p>
          </div>
          <div v-else-if="statusAtual === 'conectado'" class="py-4">
            <i class="ri-checkbox-circle-line text-success" style="font-size: 3rem;"></i>
            <div class="mt-2"><strong>Conectado!</strong></div>
            <div v-if="modoLote" class="text-muted small mt-1">{{ conectadosNoLote }} chip(s) conectado(s) nesta sequência.</div>
          </div>
          <div v-else-if="erroConexao" class="py-4">
            <i class="ri-error-warning-line text-danger" style="font-size: 2.5rem;"></i>
            <div class="mt-2 text-danger"><strong>Não foi possível iniciar</strong></div>
            <p class="text-muted mt-2 mb-0" style="font-size: 0.85rem;">{{ erroConexao }}</p>
          </div>
          <div v-else class="py-4 text-muted">
            <i class="ri-loader-4-line spin" style="font-size: 2rem;"></i>
            <div class="mt-2">Aguardando QR code...</div>
          </div>
        </div>
        <div class="modal-baileys-footer">
          <button
            v-if="statusAtual !== 'conectado'"
            type="button"
            class="btn btn-primary"
            @click="gerarNovoQr"
          >
            <i class="ri-qr-code-line me-1"></i>Gerar novo QR
          </button>
          <button
            v-if="modoLote && statusAtual === 'conectado'"
            type="button"
            class="btn btn-warning"
            @click="conectarProximoDisparo"
          >
            <i class="ri-arrow-right-line me-1"></i>Próximo chip
          </button>
          <button type="button" class="btn btn-light" @click="fecharQr">Fechar</button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.spin { display: inline-block; animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

.modal-baileys-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1080;
}
.modal-baileys-content {
  background: var(--vz-card-bg, #fff);
  color: var(--vz-body-color, inherit);
  border-radius: 12px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  border: 1px solid var(--vz-border-color, transparent);
}
[data-bs-theme="dark"] .modal-baileys-content {
  background: var(--vz-card-bg, #2a2f3a);
}
.modal-baileys-header,
.modal-baileys-footer {
  padding: 1rem 1.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--vz-border-color);
}
.modal-baileys-footer {
  border-bottom: none;
  border-top: 1px solid var(--vz-border-color);
  justify-content: flex-end;
  gap: 0.5rem;
}
.modal-baileys-body { padding: 1.25rem; }

.tipo-card {
  display: flex; align-items: flex-start; gap: 0.6rem;
  padding: 0.65rem 0.8rem;
  border: 1px solid var(--vz-border-color);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.1s, border-color 0.1s;
  background: var(--vz-body-bg);
  margin: 0;
}
.tipo-card:hover { background: var(--vz-tertiary-bg); }
.tipo-card--ativo { border-color: var(--vz-primary); background: var(--vz-primary-bg-subtle); }
[data-bs-theme="dark"] .tipo-card { background: rgba(255,255,255,0.02); }
[data-bs-theme="dark"] .tipo-card:hover { background: rgba(255,255,255,0.05); }
[data-bs-theme="dark"] .tipo-card--ativo { background: var(--vz-primary-bg-subtle, rgba(151, 18, 25, 0.16)); border-color: var(--vz-primary); }
.tipo-card input[type="checkbox"] { margin-top: 0.3rem; }
.tipo-info { display: flex; flex-direction: column; flex: 1; }
.tipo-info small { line-height: 1.3; }

.pool-disparo { background: var(--vz-tertiary-bg, var(--vz-body-bg)); }
.pool-kpi { padding: 0.4rem; border-radius: 8px; background: var(--vz-card-bg, var(--vz-body-bg)); border: 1px solid var(--vz-border-color); }
[data-bs-theme="dark"] .pool-disparo { background: rgba(255, 255, 255, 0.02); }
</style>
